<template>
  <div>

    <SocialConnectItem
      :name="'Microsoft'"
      :disconnect="disconnect('microsoft')"
      :connectURL="microsoftURL"
      :enable="enableMicrosoft"
      :loading="this.loading['microsoft']"
      :connected="connected('microsoft')">
      <MicrosoftBlack slot="icon"/>
    </SocialConnectItem>

    <SocialConnectItem
      :name="'Google'"
      :disconnect="disconnect('google')"
      :connectURL="googleURL"
      :enable="enableGoogle"
      :loading="this.loading['google']"
      :connected="connected('google')">
      <GoogleBlack slot="icon"/>
    </SocialConnectItem>

    <SocialConnectItem
      :name="'Clever'"
      :disconnect="disconnect('clever')"
      :connectURL="cleverURL"
      :enable="enableClever"
      :loading="this.loading['clever']"
      :connected="connected('clever')">
      <CleverBlack slot="icon"/>
    </SocialConnectItem>

    <FormErrors :errors="nonFieldErrors" v-if="nonFieldErrors"/>
    <FormErrors :errors="emailErrors" v-if="emailErrors"/>

  </div>
</template>

<script>
// TODO: Determine and display errors for connecting accounts

import MicrosoftBlack from './MicrosoftIconBlack'
import GoogleBlack from './GoogleIconBlack'
import CleverBlack from './CleverIconBlack'
import SocialConnectItem from './SocialConnectItem'
import FormErrors from './FormErrors'

import store from '../store'
import { socialDisconnect } from '../actionTypes'
import { setErrorSocialLogin } from '../mutationTypes'

const addState = (str, state) => (str + `&state=${state}`)

import {
  OAuthMicrosoftConnectURL,
  OAuthGoogleConnectURL,
  OAuthCleverConnectURL,

  OAUTH_GOOGLE_CLIENT_ID,
  OAUTH_MICROSOFT_CLIENT_ID,
  OAUTH_CLEVER_CLIENT_ID,
} from '../settings'

export default {
  name: 'SocialConnect',
  components: {
    MicrosoftBlack,
    GoogleBlack,
    CleverBlack,
    SocialConnectItem,
    FormErrors,
  },
  props: {
    accounts: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      state: null,
      loading: {
        'google': false,
        'microsoft': false,
        'clever': false,
      }
    }
  },
  methods: {
    connected (provider) {
      return this.accounts[provider] != null
    },
    disconnect (provider) {
      return () => {
        this.loading[provider] = true
        const providerID = this.accounts[provider]
        store.dispatch(socialDisconnect, providerID)
        .then(() => { this.loading[provider] = false })
        .catch(() => { this.loading[provider] = false })
      }
    }
  },
  mounted () {
    const state = crypto.getRandomValues(new Uint32Array(1))[0].toString()
    localStorage.setItem('state', state)
    this.state = state
  },
  beforeDestroy () {
    // Clear any errors
    store.commit(setErrorSocialLogin, {})
  },
  computed: {
    microsoftURL () {
      return addState(OAuthMicrosoftConnectURL, this.state)
    },
    googleURL () {
      return addState(OAuthGoogleConnectURL, this.state)
    },
    cleverURL () {
      return addState(OAuthCleverConnectURL, this.state)
    },
    enableGoogle () {
      return OAUTH_GOOGLE_CLIENT_ID !== ''
    },
    enableMicrosoft () {
      return OAUTH_MICROSOFT_CLIENT_ID !== ''
    },
    enableClever () {
      return OAUTH_CLEVER_CLIENT_ID !== ''
    },
    emailErrors () {
      return store.state.socialLoginErrors.email
    },
    nonFieldErrors () {
      return store.state.socialLoginErrors.nonFieldErrors
    },
  }
}
</script>



// WEBPACK FOOTER //
// SocialConnect.vue?1c7783eb